export const PlainLayout = (props) => {
  return <>{props.children}</>;
};
